;(async () => {
  if (!customElements.get('product-media')) {
    const { default: Swiper, Navigation } = await import('swiper')
    const { Fancybox } = await import('@fancyapps/ui')
    await import('sweet-scroll')

    Swiper.use([Navigation])

    class ProductMedia extends HTMLElement {
      constructor() {
        super()

        // Options
        this.options = {
          closeBtnString: 'Close',
        }

        // Get options from element data and combine with this.options
        if (this?.dataset?.options) {
          const dataOptions = JSON.parse(this.dataset.options)
          this.options = {
            ...this.options,
            ...dataOptions,
          }
        }

        this.productMediaItems = this.querySelectorAll('.product-media__item')

        this.productMediaSummary = this.querySelector('.product-media__summary')
        this.productFormWrapper = document.querySelector('.product__form-wrapper')
        this.productInfo = document.querySelector('[data-product-info]')
        this.headerNav = document.querySelector('#header')
        this.productMediaSummaryButton = this.productMediaSummary.querySelector('.product__atc-trigger')
        this.productMediaSummaryHiddenClass = 'product-media__summary--hidden'
        this.productFormElement = document.querySelector('.product__form-wrapper')

        this.swiperElement = this.querySelector('[data-swiper-product-media]')
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          threshold: 5,
          touchAngle: 25,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          slidesPerView: 1,
          direction: 'horizontal',
        }

        // Initialize swiper
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)

        // Re-init swiper when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update()
          })
        }

        // Initialize fancybox
        this.fancybox()

        // Add scroll event listener to the element
        window.addEventListener('scroll', this.handleScroll.bind(this))

        // Add events to elements
        this.productMediaSummaryButton.addEventListener('touchstart', this.scrollToProductInfo.bind(this))
        this.productMediaSummaryButton.addEventListener('click', this.scrollToProductInfo.bind(this))

        // Check if media summary items should be hidden on first load
        this.toggleMediaSummaryVisibility()
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false
        }

        const closeBtnInnerHtml = `
          <span>${this.options.closeBtnString}</span>
          <svg class="icon icon-close icon--lg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>${this.options.closeBtnString}</title>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.34338 6.34315C6.7339 5.95262 7.36707 5.95262 7.75759 6.34315L12.0002 10.5858L16.2429 6.34315C16.6334 5.95262 17.2666 5.95262 17.6571 6.34315C18.0476 6.73367 18.0476 7.36683 17.6571 7.75736L13.4144 12L17.6571 16.2426C18.0476 16.6332 18.0476 17.2663 17.6571 17.6569C17.2666 18.0474 16.6334 18.0474 16.2429 17.6569L12.0002 13.4142L7.75759 17.6569C7.36707 18.0474 6.7339 18.0474 6.34338 17.6569C5.95285 17.2663 5.95285 16.6332 6.34338 16.2426L10.586 12L6.34338 7.75736C5.95285 7.36684 5.95285 6.73367 6.34338 6.34315Z" fill="currentColor"></path>
          </svg>
        `

        // Scope change for fancybox events
        const self = this

        const fancyboxOptions = {
          animated: false,
          showClass: false,
          mainClass: 'product-media-fancybox',
          autoFocus: false,
          placeFocusBack: false,
          Toolbar: {
            items: {
              counter: {
                type: 'div',
                class: 'fancybox__counter',
                html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
                tabindex: -1,
                position: 'left',
              },
              close: {
                type: 'button',
                label: 'CLOSE',
                class: 'button button--outline product-media-fancybox__toolbar-close-btn',
                html: closeBtnInnerHtml,
                tabindex: 1,
                click: function (event) {
                  event.stopPropagation()
                  event.preventDefault()
                  this.fancybox.close()
                },
              },
            },
          },
          Carousel: {
            on: {
              change: (carousel, slide) => {
                // Swipe slide to same slide as in fancybox
                if (slide >= 0) {
                  self.swiperInstance.slideTo(slide)
                }
              },
            },
          },
          on: {
            ready: (fancybox) => {
              const toolbarCloseBtn = fancybox.$container.querySelector('.product-media-fancybox__toolbar-close-btn')

              if (!toolbarCloseBtn) return

              toolbarCloseBtn.classList.remove('carousel__button')
              toolbarCloseBtn.classList.add('hidden')
            },
            done: (fancybox) => {
              const toolbarCloseBtn = fancybox.$container.querySelector('.product-media-fancybox__toolbar-close-btn')

              if (!toolbarCloseBtn) return

              toolbarCloseBtn.blur()
              toolbarCloseBtn.classList.remove('hidden')
            },
          },
        }

        Fancybox.bind('[data-fancybox]', fancyboxOptions)
      }

      /**
       * Check if media summary items should be hidden
       */
      toggleMediaSummaryVisibility() {
        const scrollOffset = window.innerHeight - this.productMediaSummary.offsetHeight
        this.productMediaSummary.classList.toggle(this.productMediaSummaryHiddenClass, this.productFormElement.getBoundingClientRect().top <= scrollOffset)
      }

      /**
       * Handle scroll on element
       */
      handleScroll() {
        // Scope it
        const self = this

        // Check if media summary items should be hidden
        this.toggleMediaSummaryVisibility()

        // Check if the add to cart part should be sticky
        const fixedClass = 'product__form-wrapper--fixed'
        let boundaryOffset = self.productInfo.getBoundingClientRect().top
        let checkScrollOffset = 0 - self.headerNav.getBoundingClientRect().height

        self.productFormWrapper.classList.toggle(fixedClass, boundaryOffset < checkScrollOffset)
      }

      /**
       * Bind event for scrolling
       * @return void
       */
      bindScrollToReviews() {
        this.indicationElements.forEach((elem) => {
          if (elem.hasAttribute('data-product-reviews-indication-link')) {
            const reviewScroller = new SweetScroll()

            elem.addEventListener('click', (event) => {
              event.preventDefault()
              const headerHeight = document.getElementById('shopify-section-header').offsetHeight

              reviewScroller.to('product-reviews', {
                offset: -(headerHeight + 32),
                duration: 1200,
                easing: 'easeOutExpo',
              })
            })
          }
        })
      }

      /**
       * Scroll to product form
       */
      scrollToProductInfo() {
        const productInfoScroller = new SweetScroll()
        const productInfoSelector = '.product__form-wrapper'
        const productInfoElement = document.querySelector(productInfoSelector)
        const headerHeight = document.getElementById('shopify-section-header').offsetHeight - 1

        // Check if product info element exists
        if (productInfoElement) {
          productInfoScroller.to(productInfoSelector, {
            offset: -headerHeight,
            duration: 1200,
            easing: 'easeOutExpo',
          })
        }
      }
    }

    customElements.define('product-media', ProductMedia)
  }
})()
